import React from "react";

function CohortLeaderboard({ leaderboard, myProgress }) {
  const getRankStyle = (rank) => {
    switch (rank) {
      case 1:
        return "text-amber-400";
      case 2:
        return "text-zinc-400";
      case 3:
        return "text-orange-700";
      default:
        return "text-zinc-600";
    }
  };

  if (!leaderboard || leaderboard.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-zinc-500 font-display">You got here before anyone else!</p>
        <p className="text-zinc-600 text-sm mt-2">Complete challenges to be the first on the leaderboard!</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <div className="text-xs font-mono text-zinc-500 uppercase tracking-wider px-2 py-2">
        Top Performers
      </div>
      {leaderboard.map((student) => (
        <div
          key={student.userId}
          className="flex items-center gap-3 px-3 py-2.5 bg-zinc-800/30 rounded-lg"
        >
          <span className={`font-display font-bold text-lg w-6 ${getRankStyle(student.rank)}`}>
            {student.rank}
          </span>
          <div className="flex-1 min-w-0">
            <div className="font-display text-sm text-zinc-200 truncate">{student.name}</div>
            <div className="font-mono text-xs text-zinc-500">
              {student.completedChallenges} challenge{student.completedChallenges !== 1 ? "s" : ""}
            </div>
          </div>
          <div className="font-mono text-sm text-emerald-400 font-medium">
            {student.totalPoints}
          </div>
        </div>
      ))}

      {/* Show user's position if not in top list */}
      {myProgress && myProgress.rank && myProgress.rank > leaderboard.length && (
        <div className="mt-4 pt-4 border-t border-zinc-800">
          <div className="text-xs font-mono text-zinc-500 uppercase tracking-wider px-2 py-2">
            Your Position
          </div>
          <div className="flex items-center gap-3 px-3 py-2.5 bg-amber-500/10 border border-amber-500/30 rounded-lg">
            <span className="font-display font-bold text-lg w-6 text-amber-400">
              {myProgress.rank}
            </span>
            <div className="flex-1 min-w-0">
              <div className="font-display text-sm text-zinc-200">You</div>
              <div className="font-mono text-xs text-zinc-500">
                {myProgress.completedChallenges} challenge{myProgress.completedChallenges !== 1 ? "s" : ""}
              </div>
            </div>
            <div className="font-mono text-sm text-emerald-400 font-medium">
              {myProgress.totalPoints}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CohortLeaderboard;
